import React from 'react';
import PropTypes from 'prop-types';
import './SearchModeCard.css';
/**
 * SearchModeCard - Clean, minimal feature card
 * Matches the current Fantomize design language
 */
const CARD_TYPES = Object.freeze({
  TEXT_SEARCH: {
    id: 'text-search',
    title: 'Text Search',
    subtitle: 'Search by occasion, style, more.',
    mobileDesc: 'Free Text',
    icon: 'search'
  },
  LEO_CHAT: {
    id: 'leo-chat',
    title: 'Chat with Leo',
    mobileTitle: 'Leo Chat',
    subtitle: 'AI Stylist',
    mobileDesc: 'AI Stylist',
    icon: 'leo'
  },
  IMAGE_SEARCH: {
    id: 'image-search',
    title: 'Image Search',
    subtitle: 'Visual Search',
    description: 'Upload a photo and match the look.',
    icon: 'camera',
    featured: true
  }
});
const SearchModeCard = ({ type, onClick }) => {
  const config = CARD_TYPES[type];
  if (!config) return null;
  const handleClick = () => onClick?.(config.id);
  const handleKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      handleClick();
    }
  };
  return (
    <div
      className={`feature-card ${config.featured ? 'featured' : ''}`}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      role="button"
      tabIndex={0}
      data-testid={`search-mode-card-${config.id}`}
    >
      {/* Icon */}
      <div className="card-icon-wrap">
        {config.icon === 'search' ? (
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="11" cy="11" r="8"/>
            <path d="M21 21l-4.35-4.35"/>
          </svg>
        ) : config.icon === 'leo' ? (
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
            {/* Robot head */}
            <rect x="6" y="4" width="12" height="9" rx="2" />
            <circle cx="10" cy="9" r="1" fill="currentColor" stroke="none" />
            <circle cx="14" cy="9" r="1" fill="currentColor" stroke="none" />
            <line x1="12" y1="1" x2="12" y2="4" />
            {/* Body / shirt shape */}
            <path d="M7 13L5 20h14l-2-7" />
            <line x1="12" y1="13" x2="12" y2="20" />
            {/* Collar */}
            <polyline points="10 13 12 15.5 14 13" />
          </svg>
        ) : config.icon === 'camera' ? (
          <svg width="22" height="22" viewBox="0 0 100 100" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <polygon points="50,6 90,28 90,72 50,94 10,72 10,28" />
            <line x1="50" y1="6" x2="50" y2="50" />
            <line x1="90" y1="28" x2="50" y2="50" />
            <line x1="90" y1="72" x2="50" y2="50" />
            <line x1="50" y1="94" x2="50" y2="50" />
            <line x1="10" y1="72" x2="50" y2="50" />
            <line x1="10" y1="28" x2="50" y2="50" />
          </svg>
        ) : null}
      </div>
      {/* Text */}
      <div className="card-text">
        <h3 className="card-title">
          {config.mobileTitle ? (
            <>
              <span className="desktop-title">{config.title}</span>
              <span className="mobile-title">{config.mobileTitle}</span>
            </>
          ) : (
            config.title
          )}
        </h3>
        {config.featured && config.subtitle && (
          <span className="card-badge">{config.subtitle}</span>
        )}
        <p className="card-desc">
          {config.featured ? config.description : config.subtitle}
        </p>
        {config.mobileDesc && (
          <p className="card-mobile-desc">{config.mobileDesc}</p>
        )}
      </div>
    </div>
  );
};
SearchModeCard.propTypes = {
  type: PropTypes.oneOf(['TEXT_SEARCH', 'LEO_CHAT', 'IMAGE_SEARCH']).isRequired,
  onClick: PropTypes.func
};
export { CARD_TYPES };
export default SearchModeCard;